<ul
  class="product-cards"
  [class.product-cards--1]="replacementOffers.length === 1"
  [class.product-cards--2]="replacementOffers.length === 2"
  *ngIf="replacementOffers"
>
  <ng-container *ngFor="let offer of replacementOffers; index as i">
    <li class="product-card" *ngIf="visible > i" [@fadeInOut]>
      <article>
        <a class="product-card__link" (click)="onCardClick(offer)">
          <section class="product-card__add-to-compare-basket">
            <div
              class="disabled-overlay"
              (click)="disableClick($event)"
              *ngIf="limitReached && !(offer | isChecked : comparisonsSelected)"
            ></div>
            <app-cta
              kind="compare-card"
              [hasCheckbox]="true"
              [isChecked]="offer | isChecked : comparisonsSelected"
              [disabled]="
                limitReached && !(offer | isChecked : comparisonsSelected)
              "
              (clicked)="onComparisonClick(offer)"
            >
              Compare
            </app-cta>
            <div class="product-card__fee">
              <ng-container *ngIf="offer?.offer_type === offerType.REPLACEMENT">
                <p class="typog-body-large-bold product-card__fee--free">
                  {{ offer?.upgrade_fee | currency : 'GBP' }}
                </p>
              </ng-container>
              <ng-container *ngIf="offer?.offer_type === offerType.UPGRADE">
                <strong class="typog-body-large-bold product-card__fee--cost">{{
                  offer?.upgrade_fee | currency : 'GBP'
                }}</strong>
              </ng-container>
            </div>
          </section>
          <ng-container *ngIf="offer?.offer_type === offerType.UPGRADE">
            <div class="fee-notice flex align--center">
              <i class="fa-light fa-sparkles"></i>
              <p>Upgrade to this model for a one-off fee.</p>
            </div>
          </ng-container>

          <div class="product-card-wrapper">
            <header>
              <app-image
                class="product-card__img"
                [src]="offer.images && (offer?.images)[0]?.url"
                [alt]="offer?.images && (offer?.images)[0]?.text"
              >
              </app-image>
              <a class="product-card__title">
                <strong class="typog-body-large-bold"
                  ><span>{{ offer?.make }}</span>
                  {{ offer?.appliance_category }}</strong
                >
                <p class="d-block">{{ offer?.model }}</p>
              </a>
            </header>
            <section class="product-card__key-features">
              <div class="key-features__wrapper">
                <ng-container *ngIf="offer?.key_features?.length">
                  <strong class="d-block mb-1">Key features</strong>
                  <ul class="list">
                    <li
                      *ngFor="
                        let feature of offer.key_features | keyFeatures;
                        let j = index
                      "
                    >
                      <p>
                        <small class="flex">
                          <div class="list__item--name">
                            {{ feature?.name }}
                          </div>
                          <ng-container *ngIf="feature?.value"
                            >:
                            <div class="list__item--value">
                              {{ feature?.value }}
                            </div>
                          </ng-container>
                        </small>
                      </p>
                    </li>
                  </ul>
                </ng-container>
              </div>
            </section>
            <dgx-components-button-text
              [iconName]="'arrow-right'"
              [iconAlign]="'right'"
              [tabIndex]="0"
              [type]="'button-text'"
            >
              See full specifications
            </dgx-components-button-text>
          </div>
        </a>
      </article>
    </li>
  </ng-container>
</ul>
